import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Svg from '../../common/components/Svg';

import {
  toggleClassIfInViewport,
  delayedToggleClassWhenItemsInViewport,
} from '../../utils/helpers/viewport';

import styles from './products-presentation.scss';

import checkSvg from '../../common/assets/icons/check-mark.svg';
import chevronSvg from '../../common/assets/icons/chevron-right.svg';

class ProductsPresentation extends React.Component {
  constructor(props) {
    super(props);
    this.$usps = [];
    this.$leftCta = null;
    this.$rightCta = null;

    if (typeof window !== 'undefined' && window.setInterval) {
      this.uspsInterval = window.setInterval(() => {
        window.requestAnimationFrame(
          delayedToggleClassWhenItemsInViewport(this.$usps, styles.visible, 100)
        );
      }, 250);

      this.ctasInterval = window.setInterval(() => {
        if (this.$leftCta) {
          window.requestAnimationFrame(
              toggleClassIfInViewport(
                // eslint-disable-next-line react/no-find-dom-node
                ReactDOM.findDOMNode(this.$leftCta),
                styles.ctaInViewport
              )
            );
        }

        if (this.$rightCta) {
          window.requestAnimationFrame(
            toggleClassIfInViewport(
              // eslint-disable-next-line react/no-find-dom-node
              ReactDOM.findDOMNode(this.$rightCta),
              styles.ctaInViewport,
              300
             )
          );
        } // endif cta right
      }, 100);
    } // endif window
  }

  componentWillUnmount() {
    this.$usps = [];

    if (typeof window !== 'undefined' && window.clearInterval) {
      window.clearInterval(this.uspsInterval);
      window.clearInterval(this.ctasInterval);
    }
  }

  render() {
    return (
      <div className={this.props.darker ? styles.darker : null}>
        <div className={styles.productsPresentation}>
          <h2>{this.props.headline}</h2>
          <div className={styles.productsContainer}>
            <div className={styles.productLeft}>
              <h3>{this.props.leftHeadline}</h3>

              <div className={styles.iconContainer}>
                <Svg src={this.props.leftIcon} className={styles.leftIcon} />
              </div>

              <ul className={styles.uspList}>
                {this.props.leftUsps.map(usp => (
                  <li key={usp} ref={(c) => { this.$usps.push(c); }}>
                    <Svg src={checkSvg} className={styles.checkIcon} />
                    {usp}
                  </li>
              ))}
              </ul>

              <div>
                <Link
                  to={this.props.leftLink}
                  className={styles.cta}
                  ref={(c) => { this.$leftCta = c; }}
                >
                Läs mer
                <Svg src={chevronSvg} className={styles.ctaChevron} />
                </Link>
              </div>
            </div>

            <div className={styles.productRight}>
              <h3>{this.props.rightHeadline}</h3>

              <div className={styles.iconContainer}>
                <Svg src={this.props.rightIcon} className={styles.rightIcon} />
              </div>

              <ul className={styles.uspList}>
                {this.props.rightUsps.map(usp => (
                  <li key={usp} ref={(c) => { this.$usps.push(c); }}>
                    <Svg src={checkSvg} className={styles.checkIcon} />
                    {usp}
                  </li>
              ))}
              </ul>

              <div>
                <Link
                  to={this.props.rightLink}
                  className={styles.cta}
                  ref={(c) => { this.$rightCta = c; }}
                >
                Läs mer
                <Svg src={chevronSvg} className={styles.ctaChevron} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProductsPresentation.propTypes = {
  headline: PropTypes.string.isRequired,
  leftHeadline: PropTypes.string.isRequired,
  leftIcon: PropTypes.string.isRequired,
  leftUsps: PropTypes.arrayOf(PropTypes.string).isRequired,
  leftLink: PropTypes.string.isRequired,
  rightHeadline: PropTypes.string.isRequired,
  rightIcon: PropTypes.string.isRequired,
  rightUsps: PropTypes.arrayOf(PropTypes.string).isRequired,
  rightLink: PropTypes.string.isRequired,
  darker: PropTypes.bool,
};

ProductsPresentation.defaultProps = {
  darker: false,
};

export default ProductsPresentation;



// WEBPACK FOOTER //
// ./blocks/ProductsPresentation/index.js